import Vue from 'vue'
import events from '@/core/events/events'
import { extendedBus } from '@/core/events/extended-bus'

const bus = extendedBus(new Vue())
events.queue = []

export const EventBus = bus
export const Eved = events



// WEBPACK FOOTER //
// ./src/event-bus.js